import bookingHero from '../../assets/booking-hero.webp';

/**
 * Universal booking banner shown under the topbar on the paid booking link.
 * The headline and tagline are part of the picture, so
 * the visible markup is just the image; a visually hidden h1 keeps the page
 * titled for screen readers and search engines.
 */
const BookingHero = () => (
	<div className="pb__hero-banner">
		<img
			className="pb__hero-img"
			src={bookingHero}
			alt="Schedule your visit — Book an appointment. Choose your professional, service, and preferred time."
		/>
		<h1 className="pb__sr-only">Book an Appointment</h1>
	</div>
);

export default BookingHero;
